var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExportFile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 14,
    viewBox: "0 0 12 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.00065 5.66667V9.66667M6.00065 9.66667L4.00065 7.66667M6.00065 9.66667L8.00065 7.66667M9.33398 13H2.66732C2.3137 13 1.97456 12.8595 1.72451 12.6095C1.47446 12.3594 1.33398 12.0203 1.33398 11.6667V2.33333C1.33398 1.97971 1.47446 1.64057 1.72451 1.39052C1.97456 1.14048 2.3137 1 2.66732 1H6.39132C6.56811 1.00004 6.73766 1.0703 6.86265 1.19533L10.472 4.80467C10.597 4.92966 10.6673 5.0992 10.6673 5.276V11.6667C10.6673 12.0203 10.5268 12.3594 10.2768 12.6095C10.0267 12.8595 9.68761 13 9.33398 13Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExportFile);
export default __webpack_public_path__ + "static/media/export-file.43418a483c11dec738b38091a9d23038.svg";
export { ForwardRef as ReactComponent };